import component from './DealFilter';

export default { component };
